import { ITvDescriptions } from '~/src/components/TariffCard';

import { ServiceIncludesItem, ServiceIncludesList, ServiceTvDetails } from '~/src/components/TariffCard/styled';

interface IIncludesProps {
    tvDescriptions: Array<ITvDescriptions>,
    openPopup: () => void,
}

const IncludesList = ({ tvDescriptions, openPopup }: IIncludesProps): JSX.Element => {
    return (
        <ServiceIncludesList>
            {tvDescriptions.map((desc, index) => (
                <ServiceIncludesItem
                    key={index}
                    withDetails={!!desc.details}
                    data-test='includes-item'
                >
                    <div dangerouslySetInnerHTML={{ __html: desc.desc }}/>
                    {desc.details &&
                        <ServiceTvDetails
                            onClick={openPopup}
                            data-test='popup-link'
                        >
                            {desc.details}
                        </ServiceTvDetails>
                    }
                </ServiceIncludesItem>
            ))}
        </ServiceIncludesList>
    );
};

export default IncludesList;
